// Keep aligned with the backend Express parent terminal states.
export const EXPRESS_TERMINAL_STATUSES: readonly string[] = [
  'completed', 'partial_success', 'failed', 'cancelled', 'canceled',
];
